__turbopack_context__.v({
  "checkboxlabel": "EffektCheckbox-module-scss-module__ueYYIW__checkboxlabel",
  "checkboxwrapper": "EffektCheckbox-module-scss-module__ueYYIW__checkboxwrapper",
  "checkmark": "EffektCheckbox-module-scss-module__ueYYIW__checkmark",
  "input": "EffektCheckbox-module-scss-module__ueYYIW__input",
  "wrapper": "EffektCheckbox-module-scss-module__ueYYIW__wrapper",
});
